import { Form } from 'react-bootstrap';
import { connect } from 'formik';
import objectPath from 'object-path';

function SelectField({
  formik,
  name,
  title,
  required,
  ariaLabel,
  handleChange,
  style,
  showValid,
  children,
  description,
  ...props
}) {
  const errors = objectPath.get(formik.errors, name);
  const touched = objectPath.get(formik.touched, name);
  const value = objectPath.get(formik.values, name);

  return (
    <>
      {title ? (
        <Form.Label htmlFor={name}>
          {title}
          {required ? '*' : null}
        </Form.Label>
      ) : null}
      {description && <p className="text-muted small">{description}</p>}
      <Form.Select
        name={name}
        id={name}
        aria-label={ariaLabel}
        onChange={(e) => {
          if (handleChange) handleChange(name);
          formik.handleChange(e);
        }}
        onBlur={formik.handleBlur}
        value={value}
        style={style}
        isValid={!errors && touched && showValid}
        isInvalid={errors && touched}
        {...props}
      >
        {children}
      </Form.Select>
      {errors && touched ? (
        <div
          className="invalid-feedback"
          {...(props['data-testid']
            ? { 'data-testid': `${props['data-testid']}-invalid-feedback` }
            : {})}
        >
          {errors}
        </div>
      ) : null}
    </>
  );
}

export default connect(SelectField);
